module.exports = __webpack_public_path__ + "static/media/total-sms-contacts-icon.8a3e9ffc.svg";